import { Fragment } from 'react';
import { noop } from 'lodash';
import { useTranslation } from 'react-i18next';
import { IFlow, BuilderIcon, useAssetTypeActions } from '@diana/core';
import { Button, CircularProgress } from '@mui/material';
import { THINGS_PAGE_NS } from './i18n';

export const BuilderButton = (props: { flow: IFlow }) => {
  const { flow } = props;
  const { t } = useTranslation(THINGS_PAGE_NS);

  const title = t('buttons.builder');

  const { actions } = useAssetTypeActions({
    flow,
    entity: flow,
    setProcessing: noop,
    refetch: noop,
    actions: { edit: { title } },
  });

  const builderAction = actions.find((action) => action.title === title);

  if (!builderAction || (builderAction.disabled && !builderAction.loading)) return <Fragment />;

  return (
    <Button
      variant="contained"
      color="secondary"
      size="small"
      sx={({ spacing }) => ({ py: 0, minHeight: spacing(4) })}
      startIcon={
        builderAction.loading ? <CircularProgress size="1em" /> : <BuilderIcon fontSize="small" />
      }
      onClick={() => {
        if (builderAction.onClick) {
          builderAction.onClick({ close: noop });
        }
      }}
    >
      {builderAction.title}
    </Button>
  );
};
